/* eslint-disable eqeqeq */
import React from 'react'

import { useTranslation } from 'react-i18next'
import BPMBasicPage from '../../../components/BPMTable/PagesCreator/BPMBasicPage'
import CMCompanyChangeFilesTableCreator from '../../../tableDefinitions/Jobs/companyManagement/CMCompanyChangeFilesTableCreator'

function CMFiles(props){
    const { t } = useTranslation(['CMFiles'])
    document.title = `${t('Integration Files')} - BubbleBPM`

    return (
        <BPMBasicPage
            tableName={'Integration Files'}
            tableCreatorCreatorId={CMCompanyChangeFilesTableCreator.getId()}
            path={props.match.url}
        />
    )
}

export default CMFiles